export enum PredictionParty {
  NDC = 'NDC',
  NPP = 'NPP'
}
